<div
  class="border border-dashed border-outline dark:border-outline-darkmode self-stretch p-6 rounded-lg inline-flex flex-col justify-center items-center gap-3 w-full"
>
  <div class="flex justify-start items-center gap-3">
    <ui-button mode="outlined" (click)="clickAdd.emit()">
      <ng-icon slot="start" name="heroPlus" size="20" class="!block" />
      {{ 'cockpit.locations.page.addAnotherLocationButton' | transloco }}
    </ui-button>
  </div>
</div>
